<ion-grid class="image-modal-wrapper">
	<ion-row class="flex mx-20 mt-20">
		<ion-col class="float-left Body_M"
			><p class="color-Whites-Default_White">{{ title }}</p></ion-col
		>
		<ion-col class="justify-end text-right"
			><ion-icon name="close-outline" (click)="closeModal()"></ion-icon
		></ion-col>
	</ion-row>
	<ion-row class="p-32 justify-center items-center">
		<img [src]="path" default="path" />
	</ion-row>
</ion-grid>
